<template>
  <div @mousemove.stop @mouseenter.stop>
    <div
      :class="{
        mark: true,
        active: isHover || infoDisplay === 'block' || ts === +occurTime,
        varguarderror: tag === 'varguardError',
        varguardfatal: tag === 'varguardFatal',
        varguardresets: tag === 'varguardFristFatal',
        tag: tag === 'tag',
        start:tag == 'flag',
        alarmCode:tag == 'alarmCode',
        instruction: tag === 'instruction', // 车辆操作记录（强行通过/非红即走）的标志位
        operationLog: tag === 'operationLog' // 车辆操作日志（一键挪车等）
      }"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    />
    <div v-if="tagList.length" class="info">
      <div v-for="item in tagList" :key="item">
        <!-- {{ tagname||tag }} -->
          {{ item }}
      </div>
      <div>
        {{ timeStr }}
      </div>
    </div>
    <div v-else-if="tag === 'operationLog'" class="info operation-log">
      <div>操作时间: {{ timeStr }}</div>
      <div v-if="tagname">操作类型: {{ tagname }}</div>
      <div v-if="operateUser">操作人: {{ operateUser }}</div>
      <div v-if="desc">说明: {{ desc }}</div>
    </div>
    <div v-else-if="tag === 'instruction'" class="info">
      <div>操作时间: {{ instructionTimeStr }}</div>
      <div>接管动作: {{ tagname }}</div>
    </div>
    <div v-else class="info">
     <div>{{ tagname||tag }}</div>
      <div>
        {{ timeStr }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, watch } from 'vue';
import { useStore } from '@/store/index';
import { getQueryVariable } from '@/utils/utils';
import { dayjs } from 'element-plus';

let store;

export default defineComponent({
  name: 'Mark',
  props: {
    ts: {
      type: Number,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    tagname:{
      type:String,
      default:''
    },
    tagList:{
      type:Array,
      default:[]
    },
    operateUser: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  created() {
    store = useStore();
  },
  data() {
    return {
      infoDisplay: 'none',
      isHover: false,
      occurTime: getQueryVariable('occurTime') || 0,
    };
  },
  mounted() {
    
    watch(
      computed(() => store.state.wsModule.createTimestamp),
      (currTs) => {
        const value = this.ts / 1000000;

        if (this.ts === +this.occurTime) {
          this.infoDisplay = 'block';
        } else if (currTs - value < 1000 && currTs >= value) {
          this.infoDisplay = 'block';
        } else if (!this.isHover) {
          this.infoDisplay = 'none';
        }
      },
    );

    watch(
      computed(() => this.isHover),
      (flag) => (this.infoDisplay = flag ? 'block' : 'none'),
    );
  },
  computed: {
    timeStr() {
      return dayjs(this.ts / 1000000).format('YYYY-MM-DD HH:mm:ss.SSS');
    },
    instructionTimeStr() {
      // 将时间戳(毫秒)向上取整到秒
      const ms = this.ts / 1000000;
      const roundedMs = Math.ceil(ms / 1000) * 1000;
      return dayjs(roundedMs).format('YYYY-MM-DD HH:mm:ss');
    }
  },
});
</script>
<style lang="less" scoped>
.mark {
  width: 22px;
  height: 31px;
  position: relative;
  z-index: 10;
  transform: translate(9px, -30px);
  transition: transform 0.1s;
  background-position: -9px 0;
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;

  &.active {
    transform: scale(1.6) translate(9px, -23px);
    z-index: 100;
  }

  &.varguarderror {
    background: url(@/assets/images/flag-error.png) no-repeat;
    background-size: 100% 100%;
  }
  &.varguardfatal {
    background: url(@/assets/images/flag-fatal.png) no-repeat;
    background-size: 100% 100%;
  }
  &.varguardresets {
    background: url(@/assets/images/flag-first-fatal.png) no-repeat;
    background-size: 100% 100%;
  }
  &.alarmCode {
    background: url(@/assets/images/alarm-flag.png) no-repeat;
    background-size: 100% 100%;
  }

  &.tag {
    background: url(@/assets/images/flag-tag.png) no-repeat;
    background-size: 100% 100%;
  }
  &.start {
    background: url(@/assets/images/flag-start.png) no-repeat;
    background-size: 100% 100%;
  }

  /* 车辆操作记录的蓝旗样式 */
  &.instruction {
    background: url(@/assets/images/blues-flag.png) no-repeat;
    background-size: 100% 100%;
  }

  /* 车辆操作日志（一键挪车等）的蓝旗样式 */
  &.operationLog {
    background: url(@/assets/images/blues-flag.png) no-repeat;
    background-size: 100% 100%;
  }
}

.info {
  position: absolute;
  top: -100px;
  background-color: rgba(0, 0, 0, 0.7);
  display: v-bind(infoDisplay);
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  z-index: 101;
  pointer-events: none;

  // 仅“车辆操作日志”的说明可能很长：限制宽度让它换行，
  // 不改动其它旗子悬浮框的样式。
  // 注意：本元素的定位父级是 element-plus 的 .el-slider__marks-text
  // （宽度只有旗子那么宽 + white-space: pre），直接写 white-space:normal
  // 会按父级那点宽度折行变成“竖排”，所以这里必须给一个确定的宽度。
  &.operation-log {
    width: max-content;   // 先按内容撑开（不折行）
    max-width: 320px;     // 再限制上限，超出才换行
    line-height: 1.5;
    white-space: normal;  // 覆盖父级继承来的 white-space: pre
    word-break: break-word;

    // 长说明换行后框会变高。原样式是 top:-100px（顶边固定，向下生长），
    // 框一高就会向下溢出、遮挡进度条等下方内容。
    // 这里改成“底边固定、向上生长”：底边停在旗子上方，高度随便涨都只往上顶。
    // calc 里 100% = 父级(.el-slider__marks-text)高度，+38px ≈ 旗子上移的 30px 再留 8px 间隙。
    top: auto;
    bottom: calc(100% + 38px);
  }
}
</style>
